module.exports = __webpack_public_path__ + "static/21-04-22_13-35-33_5406-ad441177f5f0025c85e226faf4af4667.jpg";